import React from "react";
import { useNavigate } from "react-router-dom";

export default function MockExamCard({ mockCompleted }) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (mockCompleted) {
      navigate("/lessonMock/mock1/final");
    } else {
      navigate("/lessonMock/mock1/reading");
    }
  };

  return (
    <div className="card bg-white p-6 rounded-xl shadow-md border border-gray-200">
      <h2 className="text-xl font-bold mb-2">TOEFL Full Mock Exam. Older Academic Version</h2>
      <p className="text-gray-700 mb-4">
        Test your readiness with a full TOEFL-style exam. Includes detailed feedback and explanations.
      </p>
      <button
        onClick={handleClick}
        className={`${
          mockCompleted ? 'bg-green-600 hover:bg-green-700' : 'bg-blue-600 hover:bg-blue-700'
        } text-white font-semibold px-5 py-2 rounded-md transition-all`}
      >
        {mockCompleted ? 'See Review' : 'Start Mock Exam'}
      </button>
    </div>
  );
}
